import { render, staticRenderFns } from "./PrenotazioniPEStorico.vue?vue&type=template&id=7a1e210b&"
import script from "./PrenotazioniPEStorico.vue?vue&type=script&lang=js&"
export * from "./PrenotazioniPEStorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports